import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";
import { DOCUMENTATION_CATEGORY_INFO } from "@/lib/categoryInfo";
import { ADMIN } from "@/constants/testIds";

export default function AdminIncidents() {
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/incidents/all").then(({ data }) => {
      setIncidents(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Admin</p>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-4xl text-zinc-950 tracking-tight mb-8">All Incident Reports</h1>

      {loading ? (
        <div className="flex justify-center py-14"><div className="h-8 w-8 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin" /></div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-sm overflow-x-auto" data-testid={ADMIN.incidentsTable}>
          <Table>
            <TableHeader>
              <TableRow className="border-zinc-200 hover:bg-transparent">
                <TableHead className="text-zinc-500">Title</TableHead>
                <TableHead className="text-zinc-500">Category</TableHead>
                <TableHead className="text-zinc-500">Location</TableHead>
                <TableHead className="text-zinc-500">Status</TableHead>
                <TableHead className="text-zinc-500">Submitted</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {incidents.map((i) => (
                <TableRow key={i.id} data-testid={`admin-incident-row-${i.id}`} className="border-zinc-200 hover:bg-zinc-50">
                  <TableCell className="text-zinc-950 font-medium">{i.title}</TableCell>
                  <TableCell className="text-zinc-600">{DOCUMENTATION_CATEGORY_INFO[i.category]?.label || i.category}</TableCell>
                  <TableCell className="text-zinc-600">{i.location || "—"}</TableCell>
                  <TableCell className="text-[#1E3A6E]">{i.status}</TableCell>
                  <TableCell className="text-zinc-500">{new Date(i.created_at).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {incidents.length === 0 && <p className="text-center text-zinc-500 py-10">No incident reports yet.</p>}
        </div>
      )}
    </div>
  );
}
